const BASE_URL = process.env.REACT_APP_API_V1_BASE_URL || '/api/v1'

const API = {
    LOGIN: '/auth/login',
    CREATE_PRODUCT: '/auth/product-create',
    ALL_PRODUCTS: '/loan/list-products',
    ALL_EMPLOYEES_LOAN: '/loan/list-employee-loan',
    
    // Frontend loan endpoints (with loanNumber alias from LoanMapping collection)
    LOAN_STATUS: '/frontend/loan/status',          // GET /api/frontend/loan/status/:essApplicationNumber
    LOAN_RECORDS: '/frontend/loan/records',        // GET /api/frontend/loan/records
    LOAN_DETAILS: '/frontend/loan/details',        // GET /api/frontend/loan/details/:loanNumber

    LOGOUT: '/auth/logout',
    ADMIN_PROFILE: '/admin/get_admin',
    UPDATE_ADMIN: '/admin/edit_admin',
    CHANGE_PASSWORD: '/admin/change_password',

    //user section
    GET_ALL_USERS: '/admin/get_all_users',
    CREATE_USER: '/admin/create_user',              // POST
    UPDATE_USER: '/admin/update_user',              // PUT /admin/update_user/:id
    DELETE_USER: '/admin/delete_user',              // DELETE /admin/delete_user/:id
    GET_USER_DETAILS: '/admin/get_user_details',    // GET /admin/get_user_details/:id
    
    //notification section
    NOTIFICATION_LIST: '/notification/list',        // GET
    NOTIFICATION_READ: '/notification/read',        // PUT /notification/read/:id

    //message response section
    PENDING_RESPONSES: '/messages/pending-responses',
    MESSAGE_REQUEST: '/messages/request',
    MANUAL_RESPONSE: '/messages/manual-response',
    MESSAGE_STATUS: '/messages/status',
    MANUAL_LOAN_STATUS_REQUEST: '/loan-status-request',
    MANUAL_OUTGOING_MESSAGE: '/outgoing-message',

    //notification section
    ALL_NOTIFICATIONS: '/notification/list',
    RESEND_NOTIFICATION: '/notification/resend',

    //manual message triggers (all 24 types)
    MESSAGE_LOAN_DISBURSEMENT: '/messages/loan-disbursement',
    MESSAGE_LOAN_DISBURSEMENT_FAILURE: '/messages/loan-disbursement-failure',
    MESSAGE_LOAN_APPROVAL: '/messages/loan-approval',
    MESSAGE_LOAN_LIQUIDATION: '/messages/loan-liquidation',
    MESSAGE_LOAN_STATUS: '/messages/loan-status',
    MESSAGE_FULL_REPAYMENT: '/messages/full-repayment',
    MESSAGE_FULL_REPAYMENT_REQUEST: '/messages/full-repayment-request',
    MESSAGE_PARTIAL_REPAYMENT: '/messages/partial-repayment',
    MESSAGE_OFF_BALANCE_REPAYMENT: '/messages/off-balance-repayment',
    MESSAGE_LOAN_RESTRUCTURE: '/messages/loan-restructure',
    MESSAGE_RESTRUCTURE_AFFORDABILITY: '/messages/restructure-affordability',
    MESSAGE_RESTRUCTURE_BALANCE_REQUEST: '/messages/restructure-balance-request',
    MESSAGE_RESTRUCTURE_BALANCE_RESPONSE: '/messages/restructure-balance-response',
    MESSAGE_TAKEOVER_BALANCE: '/messages/takeover-balance',
    MESSAGE_TAKEOVER_DISBURSEMENT: '/messages/takeover-disbursement',
    MESSAGE_TOPUP_BALANCE: '/messages/topup-balance',
    MESSAGE_ACCOUNT_VALIDATION: '/messages/account-validation',
    MESSAGE_DEFAULTER_DETAILS: '/messages/defaulter-details',
    MESSAGE_PRODUCT_DETAIL: '/messages/product-detail',
    MESSAGE_PRODUCT_DECOMMISSION: '/messages/product-decommission',
    MESSAGE_FSP_BRANCHES: '/messages/fsp-branches',
    MESSAGE_LOAN_CHARGES: '/messages/loan-charges',
    MESSAGE_PAYMENT_ACKNOWLEDGMENT: '/messages/payment-acknowledgment',
    MESSAGE_RESPONSE: '/messages/response',
}

export default API
export { BASE_URL }
